<template>
  <div :class="jel_getClassObject(content)">
    <p>TODO: CarteListeProduitCED</p>
  </div>
</template>

<script>
// TODO:

export default {
  name: 'CarteListeProduitCED',
  // components: {
  // },
  props: {
    content: { type: Object, required: true },
  },
  methods: {
    getContentCarteListe() {
      return {
        listeElement: this.content.listeIdProduit,
        nbColonne: this.content.nbColonne,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
p {
  color: black !important;
}

.vhl-item > div {
  display: flex;
  > div {
    display: flex;
    &::v-deep > div {
      display: flex;
    }
  }
}
</style>
